"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextAndSliderSyncTool = void 0;
const TradeAPILib_1 = require("TradeAPILib");
const react_1 = require("react");
const trade_utils_lib_1 = require("trade_utils_lib");
exports.TextAndSliderSyncTool = {
    // slider means 0-1
    useSeparateTradingSync: (actionType, perAmount, investPercent, side, count, sumPrice, available, symbol) => {
        const lastPerAmount = (0, react_1.useRef)('');
        const lastPercent = (0, react_1.useRef)(undefined);
        const lastVolume = (0, react_1.useRef)('');
        (0, react_1.useMemo)(() => {
            if (actionType !== "text") {
                return;
            }
            lastPerAmount.current = perAmount;
            if (!Number(available) || Number(count) < 2 || !Number(sumPrice)) {
                lastPercent.current = 0;
                return;
            }
            const volume = new trade_utils_lib_1.SafeDecimal(perAmount).mul(new trade_utils_lib_1.SafeDecimal(sumPrice));
            lastVolume.current = trade_utils_lib_1.NumberCommonUtils.formatterDecimalToStr(volume, symbol.precision);
            let percent = 0;
            if (side === TradeAPILib_1.ExchangeOrderSide.buy) {
                percent = volume.div(new trade_utils_lib_1.SafeDecimal(available)).toNumber();
            }
            else {
                percent = new trade_utils_lib_1.SafeDecimal(perAmount).mul(new trade_utils_lib_1.SafeDecimal(count)).div(available).toNumber();
            }
            lastPercent.current = percent > 1 ? 1 : percent;
        }, [actionType, perAmount]);
        (0, react_1.useMemo)(() => {
            if (actionType !== "slider") {
                return;
            }
            if (!Number(available) || Number(count) < 2 || !Number(sumPrice)) {
                lastVolume.current = "0";
                lastPerAmount.current = "";
                return;
            }
            lastPercent.current = investPercent;
            let amount = "";
            if (side === TradeAPILib_1.ExchangeOrderSide.buy) {
                amount = new trade_utils_lib_1.SafeDecimal(investPercent).mul(new trade_utils_lib_1.SafeDecimal(available)).div(new trade_utils_lib_1.SafeDecimal(sumPrice)).toString();
            }
            else {
                amount = new trade_utils_lib_1.SafeDecimal(investPercent).mul(new trade_utils_lib_1.SafeDecimal(available)).div(new trade_utils_lib_1.SafeDecimal(count)).toString();
            }
            lastPerAmount.current = amount === "0" ? "" : trade_utils_lib_1.NumberCommonUtils.formatterDecimalToStr(amount, symbol.amount);
            lastVolume.current = trade_utils_lib_1.NumberCommonUtils.formatterDecimalToStr(new trade_utils_lib_1.SafeDecimal(amount).mul(new trade_utils_lib_1.SafeDecimal(sumPrice)), symbol.precision);
        }, [investPercent, actionType]);
        (0, react_1.useMemo)(() => {
            if (!Number(available) || !Number(sumPrice)) {
                lastPercent.current = 0;
                lastVolume.current = "0";
                return;
            }
            const volume = new trade_utils_lib_1.SafeDecimal(lastPerAmount.current).mul(new trade_utils_lib_1.SafeDecimal(sumPrice));
            lastVolume.current = trade_utils_lib_1.NumberCommonUtils.formatterDecimalToStr(volume, symbol.precision);
            let percent = 0;
            if (side === TradeAPILib_1.ExchangeOrderSide.buy) {
                percent = volume.div(new trade_utils_lib_1.SafeDecimal(available)).toNumber();
            }
            else {
                percent = new trade_utils_lib_1.SafeDecimal(lastPerAmount.current).mul(new trade_utils_lib_1.SafeDecimal(count)).div(available).toNumber();
            }
            lastPercent.current = percent > 1 ? 1 : percent;
        }, [side, count, sumPrice, available]);
        if (actionType === "text") {
            return [lastPerAmount.current, lastPercent.current, lastVolume.current];
        }
        else {
            return [lastPerAmount.current, undefined, lastVolume.current];
        }
    },
    useTextAndSlider: (actionType, textValue, sliderValue, min, max, isTextMul100 = false, textPrecision = 4) => {
        const lastInvest = (0, react_1.useRef)('');
        const lastPercent = (0, react_1.useRef)(undefined);
        const [minValue, maxValue] = (0, react_1.useMemo)(() => {
            return [new trade_utils_lib_1.SafeDecimal(min), new trade_utils_lib_1.SafeDecimal(max)];
        }, [min, max]);
        (0, react_1.useMemo)(() => {
            if (actionType !== "text") {
                return;
            }
            lastInvest.current = textValue;
            let value = new trade_utils_lib_1.SafeDecimal(textValue);
            if (isTextMul100) {
                value = value.div(100);
            }
            if (value.lessThan(minValue)) {
                value = minValue;
            }
            else if (value.greaterThan(maxValue)) {
                value = maxValue;
            }
            lastPercent.current = value.toNumber();
        }, [textValue, actionType]);
        (0, react_1.useMemo)(() => {
            if (actionType !== "slider") {
                return;
            }
            let numberResult = new trade_utils_lib_1.SafeDecimal(sliderValue);
            if (numberResult.lessThan(minValue)) {
                numberResult = minValue;
            }
            else if (numberResult.greaterThan(maxValue)) {
                numberResult = maxValue;
            }
            lastPercent.current = numberResult.toNumber();
            const text = isTextMul100 ? trade_utils_lib_1.NumberCommonUtils.formatterDecimalToStr(numberResult.mul(100), textPrecision) : trade_utils_lib_1.NumberCommonUtils.formatterDecimalToStr(numberResult, textPrecision);
            lastInvest.current = text === "0" ? "" : text;
        }, [sliderValue, actionType]);
        (0, react_1.useMemo)(() => {
            let value = new trade_utils_lib_1.SafeDecimal(lastInvest.current);
            if (isTextMul100) {
                value = value.div(100);
            }
            if (value.lessThan(minValue)) {
                value = minValue;
            }
            else if (value.greaterThan(maxValue)) {
                value = maxValue;
            }
            lastPercent.current = value.toNumber();
        }, [minValue, maxValue, isTextMul100]);
        if (actionType === "text") {
            return [lastInvest.current, lastPercent.current];
        }
        else {
            return [lastInvest.current, undefined];
        }
    },
    useInvestAndInvestPercent(actionType, price, invest, investPercent, side, available, investPrecision, enableChangedWithPrice = true) {
        const lastInvest = (0, react_1.useRef)('');
        const lastPercent = (0, react_1.useRef)(undefined);
        (0, react_1.useMemo)(() => {
            if (actionType !== "text") {
                return;
            }
            lastInvest.current = invest;
            if (!Number(available)) {
                lastPercent.current = 0;
                return;
            }
            let percent = 0;
            if (side === TradeAPILib_1.ExchangeOrderSide.buy) {
                const volume = new trade_utils_lib_1.SafeDecimal(invest).mul(new trade_utils_lib_1.SafeDecimal(price));
                percent = volume.div(new trade_utils_lib_1.SafeDecimal(available)).toNumber();
            }
            else {
                percent = new trade_utils_lib_1.SafeDecimal(invest).div(available).toNumber();
            }
            lastPercent.current = percent > 1 ? 1 : percent;
        }, [invest, actionType]);
        (0, react_1.useMemo)(() => {
            if (actionType !== "slider") {
                return;
            }
            if (!Number(available)) {
                lastInvest.current = "";
                return;
            }
            lastPercent.current = investPercent;
            let amount = "";
            if (side === TradeAPILib_1.ExchangeOrderSide.buy) {
                if (!Number(price)) {
                    lastInvest.current = "";
                    return;
                }
                amount = new trade_utils_lib_1.SafeDecimal(investPercent).mul(new trade_utils_lib_1.SafeDecimal(available)).div(new trade_utils_lib_1.SafeDecimal(price)).toString();
            }
            else {
                amount = new trade_utils_lib_1.SafeDecimal(investPercent).mul(new trade_utils_lib_1.SafeDecimal(available)).toString();
            }
            lastInvest.current = amount === "0" ? "" : trade_utils_lib_1.NumberCommonUtils.formatterDecimalToStr(amount, investPrecision);
        }, [investPercent]);
        const hadUpdateWithOtherParams = (0, react_1.useRef)(false);
        const updateWithOtherParams = (0, react_1.useCallback)((_available, _price, _side) => {
            if (!Number(_available)) {
                lastPercent.current = 0;
                return;
            }
            const invest = new trade_utils_lib_1.SafeDecimal(lastInvest.current);
            let percent = 0;
            if (_side === TradeAPILib_1.ExchangeOrderSide.buy) {
                const volume = invest.mul(new trade_utils_lib_1.SafeDecimal(_price));
                percent = volume.div(new trade_utils_lib_1.SafeDecimal(_available)).toNumber();
            }
            else {
                percent = invest.div(_available).toNumber();
            }
            lastPercent.current = percent > 1 ? 1 : percent;
            hadUpdateWithOtherParams.current = true;
        }, []);
        (0, react_1.useMemo)(() => {
            updateWithOtherParams(available, price, side);
        }, [side, available]);
        (0, react_1.useMemo)(() => {
            if (enableChangedWithPrice) {
                updateWithOtherParams(available, price, side);
            }
        }, [price, enableChangedWithPrice]);
        if (actionType === "text" || hadUpdateWithOtherParams.current) {
            hadUpdateWithOtherParams.current = false;
            return [lastInvest.current, lastPercent.current];
        }
        else {
            return [lastInvest.current, undefined];
        }
    },
    useGridInvestAndInvestPercent(investAction, invest, investPercent, totalAvailable, investPrecision) {
        return this.useInvestAndInvestPercent(investAction, "", invest, investPercent, TradeAPILib_1.ExchangeOrderSide.sell, totalAvailable, investPrecision);
    },
};
